import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actionCreators } from 'react/api/actions/routeSurveyModal';
import * as selectors from 'react/api/selectors/routeSurveyModal';
import Rating from 'react/components/monet/fields/rating.jsx';
import PhotoGallery from 'react/components/PhotoGallery.js';
import SurveyAnswerEntity from './SurveyAnswerEntity.jsx';
import SurveyAnswerSignature from './SurveyAnswerSignature.jsx';
import { replaceAttributeWithValue } from 'react/utils/utils';

class SurveyDetails extends React.Component {
  renderAnswer = (surveyQuestion) => {
    const { routeId, stopId } = this.props;

    const answers = surveyQuestion.get('answers');
    if (!answers.size) {
      return <div>-</div>;
    }
    switch (surveyQuestion.get('type')) {
      case 'PICKLIST':
        return (
          surveyQuestion.get('surveyQuestionDomain')
            .sortBy((domain) => domain.get('surveyQuestionDomainOrder'))
            .map((domain) => (
              <label key={domain.get('value')}>
                <input disabled type="radio" checked={domain.get('value') === answers.first()} />
                <span>{domain.get('value')}</span>
              </label>
            ))
        );
      case 'PICKLIST_MULTISELECT':
        return (
          surveyQuestion.get('surveyQuestionDomain')
            .sortBy((domain) => domain.get('surveyQuestionDomainOrder'))
            .map((domain) => (
              <label key={domain.get('value')}>
                <input disabled type="checkbox" checked={answers.some((val) => val === domain.get('value'))} />
                <span>{domain.get('value')}</span>
              </label>
            ))
        );
      case 'ENTITY':
        return (
          <SurveyAnswerEntity
            surveyQuestion={surveyQuestion}
            answers={answers}
            routeId={routeId}
            stopId={stopId}
          />
        );
      case 'CHECKBOX':
        return <input disabled type="checkbox" checked={answers.first() === 'true'} />;
      case 'TEXT_AREA':
        return <textarea disabled value={answers.first()} />;
      case 'RATING':
        return <Rating value={answers.first()} />;
      case 'SIGNATURE':
        return <SurveyAnswerSignature
          surveyAnswerId={answers.first()?.match(/.*\/(.+?)\./)?.[1]}
          routeId={routeId}
          stopId={stopId}
        />;
      case 'DATE':
        return <input disabled type="text" value={Monet.Format.Date.formatToLocale(answers.first())} />;
      case 'TIME':
        return <input disabled type="text" value={Monet.Format.Time.formatToLocale(Monet.Format.Time.parse(answers.first()))} />;
      case 'DATE_TIME':
        return <input disabled type="text" value={Monet.Format.DateTime.formatToLocale(answers.first())} />;
      default:
        return <input disabled type="text" value={answers.first()} />;
    }
  };

  renderItem = (surveyQuestion) => {
    const { photoAlbums } = this.props;
    const photoAlbum = photoAlbums.get(`${surveyQuestion.get('id')}`);
    return (
      <div key={`item${surveyQuestion.get('id')}`} className="route-survey-modal__survey-details-item">
        <div className="route-survey-modal__survey-details-item__question">
          {surveyQuestion.get('question')}
        </div>
        <div className="route-survey-modal__survey-details-item__answer">
          {this.renderAnswer(surveyQuestion)}
        </div>
        {
          photoAlbum && <PhotoGallery photoAlbum={photoAlbum} />
        }
        {
          surveyQuestion.get('subQuestions')?.size && (
            <div className="route-survey-modal__survey-details-item__sub-questions">
              {surveyQuestion.get('subQuestions').map(this.renderItem)}
            </div>
          )
        }
      </div>
    );
  };

  renderSection = (surveySection) => {
      const { survey } = this.props;
      const sectionTitle = replaceAttributeWithValue(surveySection.get('title'), survey);
      return (
          <div key={`surveySection${surveySection.get('id')}`} className="route-survey-modal__survey-section">
              <div className="route-survey-modal__survey-section__title">
                  {sectionTitle}
              </div>
              <div className="route-survey-modal__survey-section__content">
                  {surveySection.get('surveyQuestions').map(this.renderItem)}
              </div>
          </div>
      );
  };

  render() {
    const { survey } = this.props;
    return (
      <div className="route-survey-modal__survey-details">
        {survey?.get('surveySections').map(this.renderSection)}
      </div>
    );
  }
}

SurveyDetails.propTypes = {
  // state
  routeId: PropTypes.string.isRequired,
  stopId: PropTypes.string,
  survey: PropTypes.object.isRequired,
  photoAlbums: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  photoAlbums: selectors.getPhotoAlbums(state, ownProps)
});

const mapDispatchToProps = {
  fetchPhotoAlbumsAction: actionCreators.fetchPhotoAlbums
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyDetails);
